<script lang="ts" setup>
import type { SearchFiltersPanelProps } from './SearchFiltersPanel.props.ts'

defineProps<SearchFiltersPanelProps>()
defineEmits(['applyFilters'])

const { selectedFilters, formatFilterLabel } = useSearchFilters()
</script>

<template>
  <div
    class="max-lg:bg-primitives-off-white pb-8 pt-6 max-lg:mb-6 max-lg:w-full max-lg:px-10 lg:sticky lg:top-[165px] lg:max-h-[calc(100dvh-165px)] lg:w-full lg:overflow-y-auto lg:pr-2"
  >
    <div>
      <UIDropdown
        v-for="(filter, filterKey) in filters"
        :key="filterKey"
        :title="$ts(`search.filters.list.${filterKey.toString()}`)"
        class="border-primitives-grey-50 border-t first-of-type:border-none"
      >
        <ul class="grid grid-cols-1">
          <li
            v-for="(resultsNumber, resultKey) in filter"
            :key="`${resultKey}_${resultsNumber}`"
            class="mb-6 flex gap-1"
          >
            <InputsCheckboxWithSlot
              v-if="resultsNumber > 0"
              :id="`${resultKey}_${resultsNumber}`"
              v-model="selectedFilters[filterKey.toString()]"
              :name="`${resultKey} (${resultsNumber})`"
              :value="resultKey"
              is-select-size-component
            >
              <template #label>
                <span class="inline-flex flex-wrap items-center text-left">
                  {{ formatFilterLabel(resultKey) }}
                  <span class="text-light-7 text-primitives-grey-200 ml-1"
                    >({{ resultsNumber }})
                  </span>
                </span>
              </template>
            </InputsCheckboxWithSlot>
          </li>
        </ul>
      </UIDropdown>
    </div>
    <div class="flex justify-center">
      <AtomsCta
        :icon-show-default="false"
        anatomy="primary"
        class="mt-8 lg:hidden"
        @click="$emit('applyFilters')"
      >
        <template #label>
          {{ $ts('search.filters.apply') }}
        </template>
      </AtomsCta>
    </div>
  </div>
</template>
